import axios from '@api'

export default {
    getJustification() {
      return axios.get(`api/management/justification`);
    },
    deleteJustification(justificationId) {
      return axios.put(`api/management/justification/delete/${justificationId}`);
    },
    saveJustification(json) {
      return axios.post(`api/management/justification/save`, json);
    }
}